/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Dormant_NoticeInputs */



/**
* | output |
* | --- |
* | "The organization is created dormant: nobody there can sign in and nothing is billed until the term starts. oneAI must approve the contract before it activate..." |
*
* @param {Partner_Add_Customer_Contract_Dormant_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_dormant_notice = /** @type {((inputs?: Partner_Add_Customer_Contract_Dormant_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Dormant_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Organisation wird ruhend angelegt: Bis zum Laufzeitbeginn kann sich dort niemand anmelden und es wird nichts abgerechnet. oneAI muss den Vertrag freigeben, bevor er aktiviert wird. Für einen sofortigen Start wählen Sie das heutige Datum — die Organisation wird dann mit der Freigabe durch oneAI aktiv.")
	return /** @type {LocalizedString} */ ("The organization is created dormant: nobody there can sign in and nothing is billed until the term starts. oneAI must approve the contract before it activates. To start right away, choose today — it activates the moment oneAI approves it.")
});